import { browserMeta } from './browser';
import { pageMeta } from './page';
export const defaultMetas = [browserMeta, pageMeta];
//# sourceMappingURL=const.js.map